React = require 'react'
ReactDOM = require 'react-dom'

Landing = require './landing'

ReactDOM.render(React.createElement(Landing, null), document.getElementById('app'))



// WEBPACK FOOTER //
// ./node_modules/cjsx-loader!./src/meta-app/hydrate-landing.cjsx